function isElementInViewport (el) {
    // Special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
    );
}

function resizeDebounce(){
    let bannerTop = $('.banner-component-layout').find('.position-top');
    const stickyMenu = $("#stickyMenu").not(".js-menuholder");
    if (bannerTop.length === 1) {
        $('.fshr-documentWrapper').css("padding-top", bannerTop.height() + 'px');
        stickyMenu.sticky({topSpacing:bannerTop.height()});
    }
}

function handleWebLayer() {
    let maxRepeats = 0;
    const documentWrapper = $('.fshr-documentWrapper');
    const stickyMenu = $("#stickyMenu").not(".js-menuholder");
    const interval = setInterval(function() {
        maxRepeats++;
        let bannerTop = $('.banner-component-layout').find('.position-top');

        if (bannerTop.length === 1) {
            documentWrapper.css("padding-top", bannerTop.height() + 'px'); 
            stickyMenu.sticky({topSpacing:bannerTop.height()});
            handleBannerClose();
            clearInterval(interval);
        }
        if (maxRepeats > 10) {
            clearInterval(interval);
        }
      }, 300);
    
    var doit;
    window.onresize = function(){
      clearTimeout(doit);
      doit = setTimeout(resizeDebounce, 100);
    };
}

function handleBannerClose() {
    const documentWrapper = $('.fshr-documentWrapper');
    const bannerTop = $('.banner-component-layout').find('.position-top');
    const bannerTopBtn = bannerTop.find('.banner-component-close');
    const stickyMenu = $("#stickyMenu").not(".js-menuholder");
    if (bannerTop.length === 1) {
        bannerTopBtn.on('click', function () {
            documentWrapper.css("padding-top", '0px'); 
            stickyMenu.sticky({topSpacing:0});
        });
    }
}

jQuery(document).ready(function($){

    handleWebLayer();

    /// OTEVÍRAČ A ZAVÍRAČ ZÁJEZDŮ
    var allContainers = $(".js-showMoreContainer");

    $("body").on("initialize-showmorecontainer", ".js-showMoreContainer", function (e) {
        var limitView = $(this).data("showonly") ? $(this).data("showonly") : 6;
        var limitViewMobile = $(this).data("showonlymobile") ? $(this).data("showonlymobile") : limitView;
        if($(document).outerWidth() < 800){
            $(this).find(".fshr-bargainTrip, .segment-row-4, .segment-row-full, .js-commonElement").not(".no-showmore").hide().slice(0,limitViewMobile).show();
            if($(this).find(".fshr-bargainTrip, .segment-row-4, .segment-row-full, .js-commonElement").not(".no-showmore").length <= limitViewMobile){
                $(this).find(".js-opener").hide();
            }
        }else {
            $(this).find(".fshr-bargainTrip, .segment-row-4, .segment-row-full, .js-commonElement").not(".no-showmore").hide().slice(0,limitView).show();
            if($(this).find(".fshr-bargainTrip, .segment-row-4, .segment-row-full, .js-commonElement").not(".no-showmore").length <= limitView){
                $(this).find(".js-opener").hide();
            }
        }

    });

    allContainers.trigger("initialize-showmorecontainer");

    $("body").on("click",".js-showMore", function(e){

        var loadonly = $(this).data("loadonly") ? $(this).data("loadonly") : false;
        var switchbutton = true;

        var textButtOpen = $(this).data("textopen") ? $(this).data("textopen") : "Načíst další nabídky";
        var textButtClose = $(this).data("textclose") ? $(this).data("textclose") : "Skrýt další nabídky";

        if($(this).hasClass("js-opener")){
            var elementsToShow = $(this).parents(".js-showMoreContainer").find(".segment-row-4, .fshr-bargainTrip, .segment-row-full, .js-commonElement").not(".no-showmore");
            elementsToShow = elementsToShow.filter(function(){
                var element = $(this);
                console.log(element.css("display"));
                if(element.css("display") === "none"){
                    return true;
                }
                return false;
            });



            if(loadonly){
                if(elementsToShow.length > loadonly){
                    switchbutton = false;
                }
                elementsToShow = elementsToShow.slice(0, loadonly);
            }


            elementsToShow.slideDown(300, function(e){
                $(this).closest(".js-sameHeight").trigger("set-same-height");
                $(this).find(".js-lazyLoad").trigger("need-to-load");
            });

            if(switchbutton){
                $(this).removeClass("js-opener").addClass("js-closer");

                if($(this).hasClass("fshr-button")){
                    $(this).removeClass("fshr-icon--littleArrowDown");
                    $(this).addClass("fshr-icon--littleArrowUp");
                    $(this).html(textButtClose);
                }else{
                    $(this).html(textButtClose + '<i class="fshr-icon fshr-icon--littleArrowUp"></i>');
                }
            }

        }else if($(this).hasClass("js-closer")){
            var $mainContainer = $(this).closest(".js-showMoreContainer");
            var limitView = $mainContainer.data("showonly") ? $mainContainer.data("showonly") : 6;
            var limitViewMobile = $mainContainer.data("showonlymobile") ? $mainContainer.data("showonlymobile") : limitView;

            $("html, body").animate( {scrollTop: $mainContainer.offset().top}, 500,'swing');

            $mainContainer.find(".segment-row-4, .fshr-bargainTrip, .segment-row-full, .js-commonElement").not(".no-showmore").each(function(index, object){
                if($(document).outerWidth() < 800){
                    if(index>(limitViewMobile-1)){
                        $(object).slideUp(300);
                    }
                }else {
                    if(index>(limitView-1)){
                        $(object).slideUp(300);
                    }
                }

            });

            $(this).removeClass("js-closer").addClass("js-opener");

            if($(this).hasClass("fshr-button")){
                $(this).removeClass("fshr-icon--littleArrowUp");
                $(this).addClass("fshr-icon--littleArrowDown");
                $(this).html(textButtOpen);
            }else{
                $(this).html(textButtOpen + '<i class="fshr-icon fshr-icon--littleArrowDown"></i>');
            }

        }

    });


    /// ACORDION
    $( ".js-accordion" ).accordion({
        heightStyle: "content",
        collapsible: true
    });

    /// MOBILE ACORDION
    if($(window).innerWidth() < 1100){
        $( ".js-mobile-accordion" ).accordion({
            heightStyle: "content",
            collapsible: true,
            active: false
        });
    }


    // EASY TABS
    $("body").on("click", ".fshr-tabLink, .js-tabLink", function(e){
        var tabsWrapper = $(this).closest(".js-tabs-container");
        if(tabsWrapper.length == 0){
            tabsWrapper = $("body");
        }

        var ajax_url = $(this).attr("data-tab-load-url") || false;
        var target = $(this).data("tabid");
        var $this = $(this);

        if(!tabsWrapper.find(".fshr-tabsItself #" + target).hasClass("current")){

            var $tab = tabsWrapper.find(".fshr-tabsItself #" + target);

            if(ajax_url && !$tab.hasClass("js-tab-ajax-loaded")){

                $tab.addClass("fshr-tab--loading");
                setTimeout(function () {

                    $.get(ajax_url, function(data){

                        $tab.html(data);

                        setTimeout(function () {
                            $tab.find(".js-lazyLoad").trigger("need-to-load");
                            $tab.find(".js-tooltip").each(globalWrapper.fshr.initializeQtip);
                        },300);

                        $tab.find(".js-readmore").trigger("readmore-initialize");
                        $tab.find(".js-showMoreContainer").trigger("initialize-showmorecontainer");
                        $tab.addClass("js-tab-ajax-loaded");
                        $tab.removeClass("fshr-tab--loading");

                    }).fail(function(e) {
                        console.log("Error happened: " + e);
                        $tab.removeClass("fshr-tab--loading");
                    });
                }, 500);
            }

            tabsWrapper.find(".fshr-tabsItself .fshr-tab").hide();
            tabsWrapper.find(".fshr-tabsItself .fshr-tab").removeClass("current");
            tabsWrapper.find(".fshr-tabLinks .fshr-tabLink, .js-tabLink").removeClass("current");
            $(this).addClass("current");
            $tab.fadeIn().addClass("current");
            $tab.find(".js-lazyLoad").trigger("need-to-load");
        }

    });

    $("body").on("click", ".fshr-tabbedLineTrips .fshr-tabLink", function(e){
        var link = $(this).data("dalsizajezdy");
        $(this).parents(".fshr-tabbedLineTrips").eq(0).find(".fshr-button").attr("href", link);
    });


    /// SLIDER
    if($(".js-tripsslider").length){
        $(".js-tripsslider").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: false,
            responsive: [
                {
                  breakpoint: 1000,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    arrows: false
                  }
                }
            ]
        });
        $(".js-tripsslider").fadeIn();
    }
    if($(".js-testimonialSlider").length){
        $(".js-testimonialSlider").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: false,
                    responsive: [
                {
                  breakpoint: 1000,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    arrows: false
                  }
                }
            ]
        });
    }

    if($(".js-centernews").length){
        $(".js-centernews").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            variableWidth: false,
                    responsive: [
                {
                  breakpoint: 1000,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                  }
                },
                {
                  breakpoint: 800,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '30px',
                    arrows: false
                  }
                }
            ]
        });
    }

    /// SUBMENU OPENER CLOSER
    $("body").on("click", ".fshr-catChooser", function(e){

        $(".fshr-catChooserOverlay").fadeIn();
        $(".fshr-catChooserSubmenu").fadeIn({
            start : function(){
                $(this).css({ display : "flex"});
            },
            complete : function(){
                $(this).addClass("opened");
            }
        });

    });

    $("body").on("click touchstart", function(e){
        if(!$(e.target).hasClass("fshr-catChooserSubmenu") && !$(e.target).hasClass("fshr-cat") && $(".fshr-catChooserSubmenu").hasClass("opened") ){
            $(".fshr-catChooserOverlay, .fshr-catChooserSubmenu").fadeOut();
            $(".fshr-catChooserSubmenu").removeClass("opened");
        }
    });


    // SCROLLING MANAGER
    if($(".js-scrollsource").data("loadtargets") == true){
        fillYourselfMenu($(".js-scrollsource"));
    }

    var sources = $(".js-scrollsource li a");
    var sourceElements = [];
    sources.each(function(index, object){
        var id = $(object).attr("href");
        var scrollElement = $(id);
        if(scrollElement.length > 0){
            sourceElements.push(scrollElement);
        }
    });

    var stickyMenuHeight = $(".fshr-stickyMenuList.js-scrollsource").outerHeight();

    var oldActive = "";
    $(window).scroll(function(e){
        var windowTopOffset = $(document).scrollTop() + stickyMenuHeight;
        var currentFound = false;
        for(var i=0; i < sourceElements.length; i++){
            var elementTopOffset = sourceElements[i].offset().top;
            var elementTopOffsetEnd = sourceElements[i].offset().top + sourceElements[i].outerHeight();
            if( windowTopOffset > elementTopOffset && windowTopOffset < elementTopOffsetEnd ){
                currentFound = true;

                if(!oldActive){
                    oldActive = $(".js-scrollsource a.active");
                }
                $('.js-scrollsource a[href="#' + sourceElements[i].attr("id") + '"]').addClass("active");
                $('.js-scrollsource a:not([href="#' + sourceElements[i].attr("id") + '"])').removeClass("active");

                if(oldActive && $(".js-scrollsource a.active").text() != oldActive.text()){
                    $(".js-scrollsource").trigger("changeActive");
                    oldActive = $(".js-scrollsource a.active");
                }


            }
        }
        if(currentFound == false){
            $(".js-scrollsource a").removeClass("active");
        }
    });


    if($(document).outerWidth() < 800){
        $(".js-scrollsource").on("changeActive", function(e){
            $(this).animate({
                scrollLeft: $(".js-scrollsource").find("li a.active").position().left
            },500);
        });
    }


    // SCROLL RIGHT ON CLICK OF ELEMENT
    $("body").on("click", ".js-scrollsource a", function(e){
        e.preventDefault();
        stickyMenuHeight = $(".fshr-stickyMenuList.js-scrollsource").outerHeight();

        var parent = $(this).closest(".js-scrollsource");
        var affectHash = parent.attr("data-affecthash") || false;
        var targetHash = $(this).attr("href");
        var target = $(targetHash);

        var aftercall = $(this).parents(".js-scrollsource").data("aftercall");
        var scrollTarget = target.offset().top - stickyMenuHeight + 2;
        if(aftercall != "undefined"){
            $("html, body").animate({scrollTop: scrollTarget}, 300, 'swing', function(){
                if(window[aftercall]){
                    window[aftercall](target);
                }
            });
        }else {
            $("html, body").animate({scrollTop: scrollTarget}, 300, 'swing');
        }
        if(affectHash && target.length > 0){
            window.location.hash = targetHash;
        }

    });

    //PARSE HASHS FROM URL
    if(window.location.hash.length > 0){
        var hash = window.location.hash;
        if($(".js-scrollsource li").length > 0){
            var link = $(".js-scrollsource li a[href=" + hash + "]");
            if(link.length > 0){
                link.trigger("click");
            }
        }else{

        }
    }


    if($(document).outerWidth() > 800){
        $(".js-paralax").paroller();
    }

    if(window.hasOwnProperty("changeHash") && window.changeHash.length > 0){
        window.location.hash = changeHash;
    }

    // HOVER na levy box
    $(".fshr-contentBox").on("mouseover", function (e){
        $(this).find(".fshr-saleBox").removeClass("firstAnimation");
        $(this).addClass("hovered");
    });

    $(".fshr-contentBox").on("mouseout", function (e){
        $(this).removeClass("hovered");
    });


    // massive accordion
    $(".js-accordionLineOpener, .js-alternativeAccordionLineOpener").on("click", function (e){
        e.stopPropagation();
        var element = $(this).closest(".js-accordionLineContainer").find(".js-accordionLineContent").eq(0);
        var parent = $(this).closest(".js-accordionLineContainer");
        if(!parent.hasClass("opened")){
            parent.find(".fshr-accordionLineOpenerSymbol").eq(0).text("–");
            element.slideDown();
            $(this).addClass("opened");
            parent.addClass("opened");
        }else {
            parent.find(".fshr-accordionLineOpenerSymbol").eq(0).text("+");
            element.slideUp();
            parent.removeClass("opened");
            $(this).removeClass("opened");
        }

    });


    // CENTERS CALL GALLERY

    $(".fshr-regionColGallery").slick({
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          arrows: true
    });




    $("body").on("readmore-initialize",".js-readmore", function (e) {
        var length = ($(this).data("maxchars") ? $(this).data("maxchars") : 100);
        var showmoretext = ($(this).data("showmoretext") ? $(this).data("showmoretext") : "Více");
        var texty = $(this).text();
        texty = texty.trim();
        var newText = texty.substring(0,length);
        var nextText = texty.substring(length);
        if(nextText.length > 0){
            $(this).html(newText + '<span class="js-nexttext" style="display:none;">' + nextText + '</span><span class="js-readmoreOpener"><span class="js-readmoreText">' + showmoretext + '</span> <i class="fshr-icon fshr-icon--arrowDown"></i></span>');
        }
    });
    $(".js-readmore").trigger("readmore-initialize");

    $("body").on("click", ".js-readmoreOpener" , function(e){
        e.preventDefault();
        var rodic = $(this).parent(".js-readmore");
        var showmoretext = (rodic.data("showmoretext") ? rodic.data("showmoretext") : "Více");
        var showlesstext = (rodic.data("showlesstext") ? rodic.data("showlesstext") : "Méně");
        if(!$(this).hasClass("opened")){
            rodic.find(".js-nexttext").show();
            $(this).addClass("opened");
            $(this).html('<span class="js-readmoreText">' + showlesstext + '</span> <i class="fshr-icon fshr-icon--arrowUp"></i>');
        }else {
            rodic.find(".js-nexttext").hide();
            $(this).removeClass("opened");
            $(this).html('<span class="js-readmoreText">' + showmoretext + '</span> <i class="fshr-icon fshr-icon--arrowDown"></i>');
        }
    });



    /*$(".fshr-letusknow").submit(function(event){
        var form = this;
        event.preventDefault();
        var serialized = $(this).serialize();
        var url = $(this).attr("action");
        $.post(url, serialized, function(data){
            $(form).find(".fshr-formMessage").slideDown();
            setTimeout(function(){
                $(".fshr-isWorking").removeClass("fshr-isWorking");
                $("#popup-letusknow").fadeOut();
                $(form).find(".fshr-formMessage").fadeOut();
                $(form).trigger("reset");
            }, 3000);

        }).fail(function(data){
            alert("Nepodařilo se formulář odeslat");
        });

    });*/


    $("body").on("click", ".js-mobilemenu-close", function(e){
       $(".fshr-mobileMenu-bumper").trigger("click");
    });


    /* checkboxes*/
    $("body").on("change",".form-control",function(e){
        var parent = $(this).parents(".special-checkbox");
        if(parent.length>0){
            if($(this).is(":checked")){
                parent.addClass("checked");
            }else{
                parent.removeClass("checked");
            }
        }
    });


    /* SHOW PASSWORD */
    $("body").on("mousedown",".js-show-password", function(e){
        $(this).addClass("active");
        $(this).parents(".form-field").find(".form-control").attr("type","text");
    });

    $("body").on("mouseup",".js-show-password", function(e){
        $(this).removeClass("active");
        $(this).parents(".form-field").find(".form-control").attr("type","password");
    });


    /* OPEN HIDE MENU */
    $("body").on("click", ".js-open-loginmenu", function(e){
        e.preventDefault();
        var loginform = $(this).closest(".fshr-loginMenuContainer").find(".js-loginmenu");

        if(loginform.length === 0){
            loginform = $(".fshr-loginMenuContainer .js-loginmenu");
        }

        if($(this).hasClass("js-open-loginmenu-delay")){
            $("html, body").animate({scrollTop: 0}, 400, "linear" , function(){
                setTimeout(function(){
                    loginform.css({display: "block"});
                    loginform.addClass("active");
                    },400);
                return 0;
            });
        }

        if(!loginform.hasClass("active")){
            loginform.css({display: "block"});
            loginform.addClass("active");

        }else{
            loginform.removeClass("active");
            loginform.css({display: "none"});
        }
    });

    /* REMOVE ELEMENT */
    $("body").on("click",".js-remove-yourself", function(e){
        e.stopPropagation();
        e.preventDefault();
        var _this = this;
        var queryserver = $(this).attr("data-queryserver") || false;
        var itemtoremove = $(this).parents(".js-remove-item") || $(this);
        var requestparams = $(this).attr("data-queryparams");
        try{
            requestparams = JSON.parse(requestparams);
        }catch(e){
            console.log("Failed to parse json from attribute. Setting default.");
            requestparams = {};
        }

        if(queryserver){
            itemtoremove.addClass("loading");
            setTimeout(function(){
                $.post(queryserver, requestparams, function(data){
                    if(typeof data == "object"){
                        if(data.hasOwnProperty("success") && data.hasOwnProperty("message")){
                            if(data.success == true){
                                checkEmpty(_this);
                                itemtoremove.remove();
                                reportMessage(data.message);
                                return;
                            }else{
                                reportMessage(data.message);
                                return;
                            }
                        }else{
                            console.log("Server response object doesn't contain predescribed attributes.");
                            return;
                        }
                    }
                    console.log("Wrong type of data returned from server.");

                }).fail(function(data){
                    console.log("HTTP request failed.");
                });
            },500);
        }else{
            itemtoremove.remove();
        }
    });


    /* DATE PICKERS */

    $("body").on("click",".js-opencal",function(e){
        $(this).addClass("fshr-datePickerOpened");

        $.datepicker.setDefaults(globalWrapper.fshr.localization.calendar);
        var item = $(this).parents(".js-container").eq(0);
        var minDate = new Date();
        var maxDate = new Date();

        minDate.setUTCFullYear(minDate.getUTCFullYear()-99);
        var yearRangeStr = minDate.getUTCFullYear() + ":" + maxDate.getUTCFullYear();

        $(this).datepicker({
            changeMonth: true,
            changeYear: true,
            minDate: minDate,
            maxDate: maxDate,
            yearRange: yearRangeStr,
            onSelect: function(dateText, inst) {
                console.log(dateText);
                item.find(".js-year").val(dateText.split('.')[2]);
                item.find(".js-month").val(dateText.split('.')[1]);
                item.find(".js-date").val(dateText.split('.')[0]);
                item.find(".form-date-field").find("input").trigger("change");
                $(inst.dpDiv).removeClass("showImportantely");
                $(inst.dpDiv).hide();

            },
        });
        $(this).find(".ui-datepicker").addClass("showImportantely");
        $(this).find(".ui-datepicker").show();
    });

    $(document).click(function(e) {
        var ele = $(e.target);
        if (!ele.hasClass("hasDatepicker") && !ele.hasClass("ui-datepicker") && !ele.hasClass("ui-icon") && !ele.hasClass("ui-datepicker-prev") && !ele.hasClass("ui-datepicker-next") && !$(ele).parent().parents(".ui-datepicker").length){
            $(".hasDatepicker .ui-datepicker").hide();
            $(".hasDatepicker .ui-datepicker").removeClass("showImportantely");
            $(".fshr-datePickerOpened").removeClass("fshr-datePickerOpened");
        }
    });

    /* CREATING GROUPS */
    var idcounter = 0;
    $("body").on("click", ".js-addContainer", function(e){
        var wrapper = $(this).parents(".js-wrapper").eq(0);
        var numberofitems = wrapper.find(">.js-container").not(".js-prototype").length;
        numberofitems++;
        var prototype = wrapper.find(">.js-prototype.js-container").eq(0).clone();
        prototype.removeClass("js-prototype").removeClass("fshr-prototype");
        prototype.find(".js-group-counter").text(numberofitems);
        idcounter++;
        prototype.find(".form-field").each(function(index, object){
            var label = $(this).find("label");
            var input = $(this).find("input");

            var id = input.attr("id");

            label.attr("for", id+idcounter);
            input.attr("id", id+idcounter);
        });

        prototype.find(".js-tooltip-initialize").each(globalWrapper.fshr.initializeQtip);

        prototype.hide();
        prototype.find(">.form-field .form-control").not(".js-form-control-checkbox").each(function(index, object){
            $(this).attr("data-form-required",true);
        });
        wrapper.find(">.js-prototype").before(prototype);
        prototype.fadeIn(300);

        var countofitems = wrapper.find(">.js-container").length;
        if(countofitems > 0){
            var label = $(this).data("multiple-label") || $(this).text();
            $(this).text(label);
        }
    });

    $("body").on("click", ".js-removeContainer", function(e){
        confirmPopup(this, "removeContainer");
    });

    $("body").on("click", ".js-cancel", function(e){
        //var c = confirm("Opravdu chcete zrušit celou skupinu?")
        confirmPopup(this, "resetGroup");
    });

    $("body").on("processGroups", ".js-form.js-form-groups", function(e, objectToSend){
        var main = $(this).find(".js-groups");
        var maxDepth = parseInt(main.find(".js-wrapper").eq(0).attr("data-wrapper-level"));
        traverseGroups(maxDepth, main, objectToSend);
        objectToSend["data"] = JSON.stringify(objectToSend);
        console.log(objectToSend);
        $(this).closest(".js-form").find(".js-form-include-group").each(function(index, obj){
            objectToSend[$(obj).attr("name")] = $(obj).val();
        });
    });

    // mobile menu opener
    $("body").on("click", ".js-openmobilemenu", function(e){
        var mobilemenu = $(this).closest(".js-menuholder, .js-mobilemenuholder").find(".js-mobilemenu");
        if(mobilemenu.hasClass("closed")){
            mobilemenu.slideDown(300);
            mobilemenu.removeClass("closed");
            $(this).find(".js-menuArrow").removeClass("fshr-icon--arrowDown").addClass("fshr-icon--arrowUp");
        }else{
            mobilemenu.slideUp(300);
            mobilemenu.addClass("closed");
            $(this).find(".js-menuArrow").removeClass("fshr-icon--arrowUp").addClass("fshr-icon--arrowDown")
        }

    });

    $("body").on("click", ".js-reset", function(e){
        confirmPopup(this, "resetForm");
    });

    $("body").on("focus", ".js-datepicker--blockMobileKeyboard", function(e){
        if($(window).outerWidth() < 800){
            console.log(this);
            $(this).trigger("blur");
        }
    });


    $("body").on("click", ".js-runWatchDog", function(e){
        /*var email = $(this).closest(".js-watchDog").find(".js-watchDogEmail").val();
        if(email.length > 0){
            console.log("mail is valid");
            var login = checkLogin(email);
            if(login){
                openWatchDogLogin();
            }else{
                openWatchDogRegister();
            }
        }else{
            console.log("mail is invalid");
            openWatchDogRegister();
        }*/
    });

    /* přenos dat do popupu */
    $("body").on("click", ".js-transferDataToPopup", function(e){
        var popupid = $(this).attr("href");
        var id = $(this).attr("data-id");
        var type = $(this).attr("data-type");
        var name = $(this).attr("data-name");
        $(popupid).find(".js-form").attr("data-id", id);
        $(popupid).find(".js-form").attr("data-type", type);
        if(typeof name != "undefined"){
            $(popupid).find(".js-transferedName").text(name);
        }

    });

    $.datepicker.setDefaults(globalWrapper.fshr.localization.calendar);




    /* synchronized horizontal scroller */
    (function(){

        /* Very simple version of synchronized scrolling*/
        $("body").on("add-scrollers", function () {
            $(this).find(".js-priceList--scroller").on("scroll", function () {
                var currentFromLeft = $(this).scrollLeft();
                $(".js-priceList--scroller").not(this).scrollLeft(currentFromLeft);
            });
        });

        $("body").on("flights-updated", function(e){
            $("#popup-ceniky .js-popupload-destination").removeAttr("data-dynamicload-id");
        });

        /*var isDragging = 0;
        var firstDragX = 0;
        var draginElement = undefined;
        var disableFollowScroll = false;

        $("body").on("addPriceListListeners", function(e){
            $(".js-priceList--scroller").on("scroll", function(e){
                if(!disableFollowScroll){
                    var handle = $(this).closest(".js-scrolling-parent").find(".js-scrollbar-handle");
                    var handleWidth = handle.outerWidth();
                    var progressbarWidth = handle.closest(".js-scrollbar").outerWidth();
                    var scrollLeft = $(this).scrollLeft();
                    var totalScrollingWidth = $(this).find(".js-priceList--scrolledElement").outerWidth();
                    var scrollingScreenWidth = $(this).outerWidth();

                    var percent = progressbarWidth / totalScrollingWidth;
                    var scrollLeftNew = percent * scrollLeft;
                    handle.css({"left": scrollLeftNew + "px"});
                    $(".js-priceList--scroller").scrollLeft($(this).scrollLeft());
                }
            });
        });

        $("body").on("scrollbarWidths", ".js-popupWindow-overlay", function(e){
            var scrollingParent = $(this).find(".js-scrolling-parent.fshr-tabContent--active");
            setScrollbarWidth(scrollingParent);
        });

        $("body").on("scrollbarWidths", ".js-tabContent", function(e){
            e.stopPropagation();
            var scrollingParent = $(this);
            setScrollbarWidth(scrollingParent);
        });

        $(window).on("resize", function(e){
            var scrollingParent = $(".js-scrolling-parent.fshr-tabContent--active");
            setScrollbarWidth(scrollingParent);
        });

        $("body").on("mousedown", ".js-scrollbar .js-scrollbar-handle", function(e){

            isDragging = 1;
            firstDragX = e.clientX;
            draginElement = $(this);
            draginElement.addClass("active");
            disableFollowScroll = true;

        }).on("mousemove", function(e){

            if(isDragging == 1){
                isDragging = 2;
            }

        });



        $("body").on("mousemove", function(e){
            if(isDragging == 2){
                var handlerWidth = draginElement.outerWidth();
                var handlerX = draginElement.offset().left;
                var mouse_distance_from_left_side = firstDragX - handlerX;
                var scrollbarElement = draginElement.closest(".js-scrollbar");
                var scrollingParent = draginElement.closest(".js-scrolling-parent");

                var maxLeft = scrollbarElement.outerWidth() - handlerWidth;
                var minLeft = 0;

                var endX = e.clientX;
                var startX = scrollbarElement.offset().left;

                var deltaX = endX - startX - mouse_distance_from_left_side;

                if(deltaX >= 0 && deltaX <= maxLeft){
                    draginElement.css({left: deltaX});
                    var totalParentWidth = scrollingParent.find(".js-priceList--scroller").eq(0).outerWidth();
                    var totalScrolledWidth = scrollingParent.find(".js-priceList--scroller .js-priceList--scrolledElement").eq(0).outerWidth();
                    var avilableScrollAmmount = totalScrolledWidth - totalParentWidth;
                    var scrollCoeficient = avilableScrollAmmount / maxLeft;

                    scrollingParent.find(".js-priceList--scroller").scrollLeft((deltaX)* scrollCoeficient);
                    firstDragX = e.clientX;
                }
            }
        }).on("mouseup", function(e){
            isDragging = 0;
            deltaX = 0;
            if(typeof draginElement != "undefined"){
                draginElement.removeClass("active");
            }
            disableFollowScroll = false;
        });

        function setScrollbarWidth(scrollingParent){
            var minScrollbarWidth = 50;
            var contentWidth = scrollingParent.find(".js-priceList--scrolledElement").outerWidth();
            var visibleWidth = scrollingParent.find(".js-priceList--scroller").outerWidth();
            var scrollbarOuterWidth = Math.floor(scrollingParent.find(".js-scrollbar").outerWidth());
            var scrollbarWidth = visibleWidth / contentWidth * scrollbarOuterWidth;
            scrollbarWidth = Math.floor(Math.max(minScrollbarWidth, scrollbarWidth));

            if(scrollbarWidth == scrollbarOuterWidth){
                scrollingParent.find(".fshr-scrollbarHolderRight").hide();
            }
            scrollingParent.find(".js-scrollbar .js-scrollbar-handle").css({width: scrollbarWidth});
        }*/
    })();


    /* enhanced form fields */
    (function(){

        var $body = $("body");

        $body.on("focusin",".form-field.form-field-enhanced:not(.form-field-vue) .form-control",function () {
            $(this).closest(".form-field-enhanced").addClass("focused");

        });

        $body.on("focusout change",".form-field.form-field-enhanced:not(.form-field-vue) .form-control",function () {

            if(!$(this).val().length > 0){
                $(this).closest(".form-field-enhanced").removeClass("focused");
                $(this).closest(".form-field-enhanced").removeClass("filled");
            }else{
                $(this).closest(".form-field-enhanced").removeClass("focused");
                $(this).closest(".form-field-enhanced").addClass("filled");
            }
        });

        // ENHANCED SETTER, FOR GLOBAL INITIALIZATION
        $body.on("enhanced-field-set", function () {

            var formControls = $(".form-field.form-field-enhanced:not(.form-field-vue) .form-control");
            formControls.each(function () {
                if($(this).val().length > 0 && !$(this).is("select")){
                    $(this).closest(".form-field.form-field-enhanced").addClass("filled");
                }
            })
        });


        // ENHANCED RADIO
        $body.on("click", ".form-field-radio:not(.form-field-vue)", function () {

            $(this).closest(".form-field-radiogroup").find("input").prop("checked", false);
            $(this).closest(".form-field-radiogroup").find(".form-control").removeClass("form-control-active-radio");

            var $input = $(this).find("input");
            $input.prop("checked", true);
            $input.trigger("change");
            $(this).find(".form-control").addClass("form-control-active-radio");

        });

        // ENHANCED SELECT
        $body.on("click", ".form-field-select-enhanced:not(.form-field-vue)", function (e) {
            e.stopPropagation();
            closeOpenSelect.call(this);
        });

        $body.on("click", ".form-field-select-enhanced:not(.form-field-vue) .form-control-fake-select", function (e) {
            e.stopPropagation();
        });

        $body.on("click", ".form-field-select-enhanced:not(.form-field-vue) .form-control-fake-select .form-control-radio", function (e) {
            chooseOption.call(this);
            $(this).closest(".form-field-select-enhanced").trigger("change", $(this).attr("data-value"));
        });

        $body.on("click", ".form-field-select-enhanced:not(.form-field-vue) .form-control-fake-select .fshr-icon", function (e) {
            var select = $(this).closest(".form-field-enhanced.form-field-select-enhanced");
            closeSelect.call(select);
        });

        $body.on("click", function () {
            closeAllSelects();
        });


        var chooseOption = function () {
            $(this).closest(".form-control-fake-select").find(".form-control-active-radio").removeClass("form-control-active-radio");
            $(this).addClass("form-control-active-radio");
            var select = $(this).closest(".form-field-select-enhanced");
            select.addClass("filled");
            select.find(".form-control-value-placeholder").text($(this).text());
            select.find("select.form-control").val($(this).attr("data-value"));
            closeSelect.call(select);
        };

        var closeAllSelects = function () {
            var selects = $(".form-field-select-enhanced:not(.form-field-vue)");
            selects.each(function () {
                closeSelect.call(this);
            });
        };

        var closeOpenSelect = function(){
            var fakeSelect = $(this).find(".form-control.form-control-fake-select");
            var arrowIcon = $(this).find(".form-control-value .fshr-icon");

            if(fakeSelect.hasClass("form-control-hidden")){
                openSelect.call(this);
            }else{
                closeSelect.call(this);
            }
        };

        var closeSelect = function(){
            var fakeSelect = $(this).find(".form-control.form-control-fake-select");
            var arrowIcon = $(this).find(".form-control-value .fshr-icon");

            arrowIcon.removeClass("fshr-icon--littleArrowUp");
            arrowIcon.addClass("fshr-icon--littleArrowDown");
            fakeSelect.slideUp(300, function () {
                fakeSelect.addClass("form-control-hidden");
            });

        };

        var openSelect = function(){
            var fakeSelect = $(this).find(".form-control.form-control-fake-select");
            var arrowIcon = $(this).find(".form-control-value .fshr-icon");

            fakeSelect.hide();
            fakeSelect.removeClass("form-control-hidden");
            fakeSelect.slideDown(300);
            arrowIcon.removeClass("fshr-icon--littleArrowDown");
            arrowIcon.addClass("fshr-icon--littleArrowUp");
        };

        var initializeSelects = function($element){
            var selects = $element.find(".form-field-select-enhanced:not(.form-field-vue)");
            selects.each(function () {
                var toSelect = $(this).find("select.form-control").val();
                var isSelected = $(this).find(".form-control-fake-select .form-control.form-control-radio[data-value=" + toSelect + "]");
                if( isSelected.length > 0 ){
                    isSelected.addClass(".form-control-active-radio");
                    $(this).find(".form-control-value-placeholder").text(isSelected.text());
                    $(this).addClass("filled");
                }
            });
        };

        $("body").on("initialize-selects", "div", function () {
           var $element = $(this);
           initializeSelects($element);
        });

        initializeSelects($("body"));

        $body.on("change", ".js-tabAlternativeNavigation .form-field-select-enhanced", function (e, data) {
            var container = $(this).closest(".js-tabs-container");
            var tablink = container.find(".js-tabLink[data-tabid=" + data + "]");
            if(tablink.length > 0){
                tablink.click();
            }

            var container2 = $(this).closest(".js-tabParent");
            var tablink2 = container2.find(".js-tabControl[data-tab-selector='#" + data + "']");
            if(tablink2.length > 0){
                tablink2.click();
            }
        });


        // ENHANCED CHECKBOX

        $body.on("click", ".js-form-field-checkbox", function (e) {
            e.stopPropagation();
            var formField = $(this).find(".form-control");
            var input = $(this).find("input");
            if(formField.hasClass("form-control-active-checkbox")){
                formField.removeClass("form-control-active-checkbox");
                input.prop("checked", false);
            }else{
                input.prop("checked", true);
                formField.addClass("form-control-active-checkbox");
            }

            input.trigger("change");

        });

        $body.on("click", ".js-form-field-checkbox label", function (e) {
            e.preventDefault();
        });



        $body.on("input", '.js-force-length', function (e) {

            var maxlength = $(this).attr("data-max-length");
            var value = $(this).val().trim().replace('\t','').length;
            var newvalue = $(this).val().trim().replace('\t','');


            newvalue = newvalue.slice(0, maxlength);
            if($(e.target).hasClass("js-date")){
                if(newvalue > 31){
                    newvalue = 31;
                }
            }

            if($(e.target).hasClass("js-month")){
                if(newvalue > 12){
                    newvalue = 12;
                }
            }

            if($(e.target).hasClass("js-year")){
                var today = new Date();
                if(newvalue > today.getFullYear()){
                    newvalue = today.getFullYear();
                }
            }

            $(this).val(newvalue);

        });

        $body.trigger("enhanced-field-set");

    })();



    /* SWITCHERS */

    (function(){
        $("body").on("click",".js-switcher",function () {

            if($(this).hasClass("neutral")){
                $(this).removeClass("neutral");
            }
            $(this).toggleClass("switched");
            var valueon = $(this).attr("data-value-on");
            var valueoff = $(this).attr("data-value-off");
            var wrapper = $(this).closest(".js-switcher-wrapper");


            var valueHolder = wrapper.find(".value-holder");

            if($(this).hasClass("switched")){
                valueHolder.val(valueon).trigger("change");
                valueHolder[0].dispatchEvent(new CustomEvent('input'));
                var seassonAnchor = wrapper.find('.js-switcherLabel[data-switch-for=' + valueon + '] .js-menuSearch');
                seassonAnchor.click();
            }else{
                var seassonAnchor = wrapper.find('.js-switcherLabel[data-switch-for=' + valueoff + '] .js-menuSearch');
                valueHolder.val(valueoff).trigger("change");
                valueHolder[0].dispatchEvent(new CustomEvent('input'));
                seassonAnchor.click();
            }

        });

        $("body").on("click",".js-switcherLabel",function () {

            var switchFor = $(this).attr("data-switch-for");
            var parent = $(this).closest(".js-switcher-wrapper");
            var switcher = parent.find(".fshr-switcher");
            var valueOn = switcher.attr("data-value-on");
            var valueOff = switcher.attr("data-value-off");

            var valueHolder = parent.find(".value-holder");
            if(switchFor == valueOn){
                switcher.removeClass("neutral");
                switcher.addClass("switched");
                valueHolder.val(valueOn).trigger("change");
                valueHolder[0].dispatchEvent(new CustomEvent('input'));
            }else if(switchFor == valueOff){
                switcher.removeClass("neutral");
                switcher.removeClass("switched");
                valueHolder.val(valueOff).trigger("change");
                valueHolder[0].dispatchEvent(new CustomEvent('input'));
            }else{
                switcher.addClass("neutral");
                switcher.removeClass("switched");
                valueHolder.val('').trigger("change");
                valueHolder[0].dispatchEvent(new CustomEvent('input'));
            }

        });

        $("body").on("switcher-set",function () {

            var switchers = $(".js-switcher-wrapper");
            switchers.each(function () {
                var settedValue = $(this).find(".value-holder").val();
                var valueOn = $(this).find(".js-switcher").attr("data-value-on");
                var valueOff = $(this).find(".js-switcher").attr("data-value-off");
                var switcher = $(this).find(".js-switcher");

                if(settedValue == valueOn){
                    switcher.addClass("switched");
                }else if(settedValue == valueOff){
                    switcher.removeClass("switched");
                }else{
                    switcher.removeClass("switched");
                    switcher.addClass("neutral");
                }
            });
        });

        $("body").trigger("switcher-set");

    })();



    /** SIMPLE H SCROLL */

    function handleHandler($wrapper) {
        var $allSteps = $wrapper.find(".js-step-length");


        if ($allSteps.length > 4) {
            $wrapper.find(".js-move-right").show();
        }else {
            $wrapper.find(".js-move-right").hide();
        }
        if($wrapper.find(".js-simple-h-scroll").scrollLeft() == 0){
            $wrapper.find(".js-move-left").hide();
        }
    }
    function moveWithShit() {
        var $trigger = $(this);
        var $wrapper = $trigger.closest(".js-simple-h-scroll-wrap");
        var $triggerLeft = $wrapper.find(".js-move-left");
        var $triggerRight = $wrapper.find(".js-move-right");
        var $allSteps = $wrapper.find(".js-step-length");
        var stepLength = $allSteps.eq(0).innerWidth();
        var $scroller = $wrapper.find(".js-simple-h-scroll");
        var currentStep = $scroller.scrollLeft() / stepLength;
        var nextStep = Math.ceil(currentStep) + 1;
        var perPage = Math.floor($scroller.innerWidth() / stepLength);
        var maxSteps = $allSteps.length - perPage;

        if ($trigger.is(".js-move-left")) {
            nextStep = Math.floor(currentStep) - 1;
        }
        if (nextStep <= 0) {
            $triggerLeft.hide();
        } else {
            $triggerLeft.show();
        }

        if (nextStep >= maxSteps) {
            $triggerRight.hide();
        } else {
            $triggerRight.show();
        }
        if (0 <= nextStep && nextStep <= maxSteps) {
            $scroller.animate({
                scrollLeft: nextStep * stepLength + 'px'
            }, 300, "swing");
        }
    }

    var $hScroll = $(".js-simple-h-scroll-wrap");
    if ($hScroll.length){

        $hScroll.each(function () {
            handleHandler($(this));
        });
        $("body").on("click", ".js-simple-h-scroll-wrap .js-move", moveWithShit);
    }


    /* SHOW BUTTON */

    $(".js-showButton").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var parent = $(this).closest(".js-showOnButtonContainer");
        var showmore = parent.attr("data-showmore") || "Více";
        var showless = parent.attr("data-showless") || "Méně";
        var button = $(this);

        if(parent.length > 0) {
            var content = parent.find(".js-showOnButton");
            if(content.length > 0){
                if(content.hasClass("fshr-showOnButton--visible")){
                    button.find(".js-showButton--value").text(showmore);
                    button.find(".fshr-icon").removeClass("fshr-icon--arrowUp").addClass("fshr-icon--arrowDown")
                    content.removeClass("fshr-showOnButton--visible");
                }else{
                    button.find(".js-showButton--value").text(showless);
                    content.addClass("fshr-showOnButton--visible");
                    button.find(".fshr-icon").removeClass("fshr-icon--arrowDown").addClass("fshr-icon--arrowUp")
                }
            }
        }
    });


    /** SLIDER REMOTE CHANGE **/
    var $carousels = $(".js-carousel");

    $carousels.on("init reInit", checkCarousels);

    $("body").on("afterChange", ".js-carousel-remote-change", function (event, slick, currentSlide ) {
        var newSlide = $(slick.$slides[currentSlide]);
        var remoteChangeID = newSlide.attr("data-remote-change");
        $(".js-teaser-change > *").removeClass("fshrRemoteChangeVisible");
        window.globalWrapper.fshr.handleLazyLoad($("body"));
        if(remoteChangeID && remoteChangeID.length > 0){
            $(".js-teaser-change " + remoteChangeID).addClass("fshrRemoteChangeVisible");
        }
    });


    /** TRANSFER DATA FROM ELEMENT TO ELEMENT **/
    $("body").on("click", ".js-transfer-el-to-el", function () {
        var data = $(this).attr("data-transfer-value");
        var toEl = $(this).attr("data-transfer-to-el");
        if(data && data.length > 0 && toEl && toEl.length > 0){
           $(toEl).text(data);
        }
    });


    /** TRANSFER CLICK EVENT **/
    $("body").on("click", ".js-transfer-click", function (e) {
        var toEl = $(this).attr("data-transfer-to-el");
        $(toEl).trigger("click", e);
    });


    /** ON HOVER START LAZY LOAD **/
    $("body").on("mouseenter",".js-onhover-lazyLoad", function (e) {
        $(this).find(".js-lazyLoad").trigger("need-to-load");
    });

    /** START ALL FUNCTIONS **/
    $("body").on("start-all-functions", function (e, source) {
        var allContainers = source.find(".js-showMoreContainer");
        allContainers.trigger("initialize-showmorecontainer");

        var allPhotos = source.find(".js-lazyLoad");
        setTimeout(function () {
            allPhotos.trigger("need-to-load");
        },200);

        var $carousels = source.find(".js-carousel");
        setTimeout(function () {
            $carousels.each(function (e) {
                $(this).trigger("initialize-carousel");
            });
        },200);

        setTimeout(function () {
            source.trigger("initialize-selects");
        },100);

        source.trigger("initializeCounters");

        source.find(".js-tooltip").each(globalWrapper.fshr.initializeQtip);
        source.find(".js-readmore").each(function (){
            $(this).trigger("readmore-initialize");
        });

    });


    /** SIMPLE LIGHT BOX **/
    $("body").on("click", ".js-simpleLightbox", function (e) {
        e.preventDefault();
        var largeImg = $(this).attr("data-largeimg");
        if((typeof largeImg)== "undefined"){
           largeImg = $(this).find("img").attr("src");
        }

        var largeImgAlt = $(this).find("img").attr("alt");

        var lightbox = $(".js-simpleLightboxWrap");

        if(lightbox.length == 0){
           lightbox = '<div class="fshr-simpleLightbox js-simpleLightboxWrap">';
           lightbox += '<span class="fshr-icon fshr-icon--cross js-closeSimpleLightbox"></span>';
           lightbox += '<div class="fshr-simpleLightboxItem">';
           lightbox += '<img src="' + largeImg + '" alt="' + largeImgAlt + '">';
           if(typeof largeImgAlt != 'undefined' && largeImgAlt.length > 0){
               lightbox += '<h3>' + largeImgAlt + '</h3>';
           }
           lightbox += '</div>';
           lightbox += '</div>';
           lightbox = $(lightbox);
           lightbox.hide();
           $("body").append(lightbox);
        }else{
            var img = lightbox.find("img");
            img.attr("src",largeImg);
            img.attr("alt", largeImgAlt);
        }

        lightbox.fadeIn();
    });


    $("body").on("click", ".fshr-simpleLightboxItem", function (e) {
        e.stopPropagation();
    });

    $("body").on("keyup", function (e) {
       if(e.originalEvent.keyCode == 27){
           var lightbox = $(".js-simpleLightboxWrap");
           if(lightbox.length > 0){
               lightbox.fadeOut();
           }
       }
    });

    $("body").on("click", ".js-simpleLightboxWrap", function (e) {
        var lightbox = $(this).closest(".js-simpleLightboxWrap");
        lightbox.fadeOut();
    });


    /** LANGUAGE SWITCHER **/
    $("body").on("click", ".js-languageBox", function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".js-loginmenu").removeClass("active");
        openCloseLanguageSelector($(this));
    });

    $("body").on("click", function () {
       openCloseLanguageSelector($(".js-languageBox"), true);
    });

    $("body").on("click", ".js-chooseLang", function (e) {
       e.stopPropagation();
    });

    function openCloseLanguageSelector($languageSelector, forceClose) {
        var chev = $languageSelector.find(".fshr-selectedLang .fshr-icon");
        if(!forceClose){
            $languageSelector.toggleClass("active");
            if(chev.hasClass('fshr-icon--arrowDown')){
                chev.removeClass('fshr-icon--arrowDown');
                chev.addClass('fshr-icon--arrowUp');
            }else{
                chev.removeClass('fshr-icon--arrowUp');
                chev.addClass('fshr-icon--arrowDown');
            }
        }else{
            $languageSelector.removeClass("active");
            chev.removeClass('fshr-icon--arrowUp');
            chev.addClass('fshr-icon--arrowDown')
        }
    }

    /* SHOW MAIN PHOTO */
    $("body").on("click",".js-showMainPhoto", function (e) {
       var image = $(this).find("img").attr("src");
       var wrapper = $(this).closest(".js-photoWrap");
       wrapper.find(".js-mainPhoto").attr("src", image);
    });

    var $gallerySlider = $('.js-gallery-slider');
    var $gallerySliderNav = $('.js-gallery-slider-nav');

    //$gallerySlider.hide();
    //$gallerySliderNav.hide();


    $('.js-gallery-slider').on('init', function(event, slick){
        $(".fshr-hotelGallery").css('opacity', '0').animate({
            opacity: 1
        }, 500);
    });

    setTimeout(function () {

        $gallerySlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            lazyLoad: 'ondemand',
            fade: false,
            asNavFor: '.js-gallery-slider-nav',
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        inifinte: true,
                        dots: true,
                        arrows: true,
                        prevArrow: '<span class="slick-prev fshr-icon fshr-icon--caretLeft"></span>',
                        nextArrow: '<span class="slick-next fshr-icon fshr-icon--caretRight"></span>'
                    }
                }
            ]
        });


        $gallerySliderNav.slick({
            slidesToShow: 4,
            lazyLoad: 'ondemand',
            slidesToScroll: 1,
            fade: false,
            asNavFor: '.js-gallery-slider',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            variableWidth: true,
            prevArrow: '<span class="slick-prev fshr-icon fshr-icon--caretLeft"></span>',
            nextArrow: '<span class="slick-next fshr-icon fshr-icon--caretRight"></span>',
            responsive: [
                {
                    breakpoint: 1100,
                    settings: "unslick"
                }
            ]
        });


    }, 100);


    $(".js-tileGallery").on("inViewport", function () {
        var tileGallery = $(".js-tileGallery");
            $(".js-tileGallery").not(".slick-initialized").slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                dots: false,
                centerMode: false,
                prevArrow: '<span class="slick-prev fshr-icon fshr-icon--caretLeft"></span>',
                nextArrow: '<span class="slick-next fshr-icon fshr-icon--caretRight"></span>',
                responsive: [
                    {
                        breakpoint: 1100,
                        settings: "unslick"
                    }
                ]
            });
    });



    $("body").on("click", ".js-unlickOnClick",function () {
       var slickSelector = $(this).attr("data-slick-selector");
       if(slickSelector.length > 0){
           $(slickSelector).slick("unslick");
           $(this).removeClass("js-refreshSlickOnClick");
       }
    });


    /* FIRE WHEN IS IN VIEW */
    var viewportFires = $(".js-fireInViewport");
    if(viewportFires.length > 0){
        $(document).scroll(function () {
            viewportFires.each(function () {
                if(isElementInViewport(this)){
                    if(!$(this).hasClass("js-alreadyInViewport")){
                        $(this).trigger("inViewport");
                        $(this).addClass("js-alreadyInViewport");
                    }
                }else{
                    $(this).removeClass("js-alreadyInViewport")
                }
            });
        });
    }




    jQuery(document).ready(function () {

        /* CHANGING OCCUPANCY */
        $("body").on("ajax-form-send-success", ".js-changeOccupancy", function () {

            $(this).find(".js-workingAfterClick").removeClass("fshr-button--disabled").removeAttr("disabled");

            var _this = this;
            setTimeout(function(){
                $(_this).find(".js-workingAfterClick").removeAttr("disabled");
            }, 500);

            setTimeout(function () {
                window.fshr.popup.close();
            }, 1500);

        });


        $("body").on("ajax-form-send-fail", ".js-changeOccupancy", function () {

            console.log("ERROR");
            $(this).find(".js-workingAfterClick").removeClass("fshr-button--disabled");
            $(this).find(".js-workingAfterClick").removeAttr("disabled");

            var _this = this;
            setTimeout(function(){
                $(_this).find(".js-workingAfterClick").removeAttr("disabled");
            }, 1500);

            alert("Došlo k chybě, kontaktujte administrátora.");

        });

    });


});



function recaptchaValidator($form){

    var prom = new Promise(function (resolve, reject) {
        if($form.hasClass("js-recaptchaValidate")){

            var sitekey = $form.attr("data-sitekey");
            var action = $form.attr("data-action") | "default";

            if(sitekey.length>0){
                    grecaptcha.ready(function() {
                        grecaptcha.execute(sitekey, {action: action}).then(function(token) {
                            var captchaEl = $(".grecaptcha-token");

                            if(captchaEl.length === 0){
                                $form.append('<input type="hidden" name="grecaptcha-token" class="grecaptcha-token" value="' + token + '">');
                            }else{
                                captchaEl.val(token);
                            }

                            $form.trigger("recaptcha-success");
                            resolve($form);
                        });
                    });
            }else{
                console.log("Required attributes not present");
            }

        }else{
            reject($form);
        }
    });

    return prom;
}

$( window ).on( "load", function() {
    checkCarousels(null, undefined);
});


function checkCarousels(event, slick) {
    var remoteChangeID = "";
    if(typeof slick != "undefined"){
        var slides = slick.$slides;
    }else{
        var slides = $(".slick-slide");
    }

    slides.filter(function (key,el) {
        var newel = $(el);
        if(newel.hasClass("slick-current")){
            remoteChangeID = newel.attr("data-remote-change");
        }
    });

    $(".js-teaser-change > *").removeClass("fshrRemoteChangeVisible");
    if(remoteChangeID && remoteChangeID.length > 0){
        $(".js-teaser-change " + remoteChangeID).addClass("fshrRemoteChangeVisible");
    }
}





function traverseGroups(depth,element,finalObject){
    depth--;
    element.find(".js-wrapper[data-wrapper-level=" + (depth + 1) + "]").each(function(index, object){

        var wrapName = $(this).attr("data-wrapper-name");
        finalObject[wrapName] = {};
        $(this).find(">.js-container").not(".js-prototype").each(function(lineIndex, container){
            finalObject[wrapName][lineIndex] = {};
            $(this).find(".form-control.form-control-level-"+(depth+1)).each(function(index, object){
                if($(this).attr("type")== "checkbox"){
                    var name = $(this).attr("name");
                    var value = $(this).is(":checked");
                    finalObject[wrapName][lineIndex][name] = value;
                }else {
                    var name = $(this).attr("name");
                    var value = $(this).val();
                    finalObject[wrapName][lineIndex][name] = value;
                }
            });

            traverseGroups(depth,$(this),finalObject[wrapName][lineIndex]);
        });

    });
}

function confirmPopup(element, action){
    if($(".confirmPopup").length){
        var confirmPopUpElement = $(".confirmPopup");
    }else{
        var confirmPopUpElement = '<div class="fshr-confirmPopup">';
        var text = $(element).attr("data-popuptext") || "Opravdu toto chcete provést";
        var confirmText = $(element).attr("data-popupconfirm") || "Potvrdit";
        var denyText = $(element).attr("data-popupdeny") || "Zrušit";

        confirmPopUpElement += '<div class="fshr-innerConfirmPopup">';
        confirmPopUpElement += '<h3 class="">' + text + '</h3>';
        confirmPopUpElement += '<div class="fshr-confirmPopupButtons"><button class="fshr-confirm js-confirm">' + confirmText + '</button><button class="fshr-deny js-deny">' + denyText + '</button></div>'
        confirmPopUpElement += '</div>';
        confirmPopUpElement += '</div>';
        confirmPopUpElement = $(confirmPopUpElement);
        $("body").append(confirmPopUpElement);
    }
    confirmPopUpElement.hide();
    confirmPopUpElement.fadeIn(300);

    confirmPopUpElement.on("click", ".js-confirm", function(e){
        window[action](element);
        confirmPopUpElement.fadeOut(300);
    });

    confirmPopUpElement.on("click", ".js-deny", function(e){
        confirmPopUpElement.fadeOut(300);
    });

}

function removeContainer (element){
    var container = $(element).parents(".js-container").eq(0);
    var _this = $(element).parents(".js-wrapper").eq(0);
    container.slideUp(300, function(){
        container.remove();
        _this.find(">.js-container").not(".js-prototype").each(function(index, object){
            $(this).find(".js-group-counter").text(index+1);
        });

        var countofcontainers = _this.find(">.js-container").not(".js-prototype").length;
        if(countofcontainers < 1) {
            var label = _this.find(">.js-controls>.js-addContainer").data("single-label") || $(this).text();
            _this.find(">.js-controls>.js-addContainer").text(label);
        }
    });



}

function resetForm(element){
    $(element).parents(".js-form").find("input.form-control").each(function(index, obj){
        $(this).removeAttr("value");
    });

    $(element).parents(".js-form").find(".form-control option").each(function(index, obj){
        $(this).removeAttr("selected");
    });

    $(element).parents(".js-form")[0].reset();
    $(element).parents(".js-form").find(".form-field").removeClass("fshr-validation-valid").removeClass("fshr-validation-error");
    $(element).parents(".js-form").find(".form-control").removeClass("fshr-validation-noValid");
}


// aftercall

function openBar(element){
    setTimeout(function(){
        if(!element.find(".js-accordionLineContainer").eq(0).hasClass("opened")){
            element.find(".js-accordionLineOpener").eq(0).trigger("click");
        }
    }, 600);
}

function fillYourselfMenu(parent){
    parent.each(function(index1, obj1){
        var identifier = $(obj1).attr("data-identifier") || false;
        $(".js-scrollTarget").each(function(index2, obj2){
            if(identifier){
                if(identifier == $(obj2).attr("data-identifier")){
                    $(obj1).append('<li class="fshr-boxedLink"><a href="#' + $(obj2).attr("id") + '">' + $(obj2).data("menuname") + '</a></li>');
                }
            }else{
                $(obj1).append('<li class="fshr-boxedLink"><a href="#' + $(obj2).attr("id") + '">' + $(obj2).data("menuname") + '</a></li>');
            }
        });
    });
}

/* REPORT ERRORS / MESSAGES */
function reportMessage(message){
    $(".js-reporter").text(message);
    $(".js-reporter").slideDown(400, function(){
        setTimeout(function(){
            $(".js-reporter").slideUp(400);
        }, 2500)
    });
}

function checkEmpty(element){
    var count = $(element).parents(".js-removeItemWrapper").find(".js-remove-item").length;
    if(count <= 1){
        $(".js-emptyInfo").removeClass("fshr-hidden");
        $(".js-removeItemWrapper").remove();
    }
}


function resetGroup(element){
    $(element).parents(".js-groups").find(">.js-wrapper").find(".js-container").not(".js-prototype").remove();
    resetForm(element);
}


function runWatchDog($pseudoForm){
    var email = $pseudoForm.find(".js-watchDogEmail").val();
    var url = $pseudoForm.attr("data-ajaxform-url") || $pseudoForm.attr("action") || window.location.href;
    var id = $pseudoForm.attr("data-id") || "";
    var type = $pseudoForm.attr("data-type") || "";

    if(email && email.length > 0){
        var login = checkLogin(email, url);
        login.then(function(argument){
            $pseudoForm.find(".fshr-isWorking").removeClass("fshr-isWorking");
            openWatchDogLogin(email, id, type);

        }, function(argument){
            $pseudoForm.find(".fshr-isWorking").removeClass("fshr-isWorking");
            openWatchDogRegister(email, id, type);
        });
    }else{
        openWatchDogRegister();
    }
}


function openWatchDogLogin(email, id, type){
    globalWrapper.fshr.popup.close();
    $popupWindow = $("#popup-watchDog");
    $popupWindow.find(".js-prefill.js-prefill-email").val(email).trigger("change");
    $popupWindow.find(".js-prefill.js-prefill-type").val(type);
    $popupWindow.find(".js-prefill.js-prefill-id").val(id);
    globalWrapper.fshr.popup.open($popupWindow);
    $popupWindow.find(".fshr-validation-error").removeClass("fshr-validation-error");
    $popupWindow.find(".fshr-validation-empty").removeClass("fshr-validation-empty");
}

function openWatchDogRegister(email, id, type){
    globalWrapper.fshr.popup.close();
    $popupWindow = $("#popup-registerWatchDog");
    $popupWindow.find(".js-prefill.js-prefill-email").val(email).trigger("change");
    $popupWindow.find(".js-prefill.js-prefill-type").val(type);
    $popupWindow.find(".js-prefill.js-prefill-id").val(id);
    globalWrapper.fshr.popup.open($popupWindow);
    $popupWindow.find(".fshr-validation-error").removeClass("fshr-validation-error");
    $popupWindow.find(".fshr-validation-empty").removeClass("fshr-validation-empty");
}


function checkLogin(email, url){
    var jsonMail = {
        "email" : email
    }
    return new Promise(function(resolve,reject){
        $.get(url, jsonMail, function(data){
            setTimeout(function(){
                if(data.status == 1){
                    resolve(data);
                }else{
                    reject(data);
                }
            },500)

        }, "json").fail(function(){
            reject("HTTPS failed");
            console.log("Failed to XHR");
        });
    });
}

/* DELETE WATCH DOG */
function DeleteWatchDog(element) {
    var watchdogid = $(element).attr("data-watchdogid");
    $.ajax({
        url: "OdeberHlidacihoPsa",
        data: { id: watchdogid },
        success: function (data) {
            if (data == "OK") {
                $("#watchdog_" + watchdogid).remove();
                if ($(".fshr-watchDogItem").length == 0) {
                    $(".js-emptyContainer").removeClass("fshr-hidden");
                    $(".fshr-watchDogItemsWrapper").hide();
                }
            }
        }
    });
}


/* TEASER PAGING */
function teaserPagging(slider, i) {
    var constructionHtml = '<div class="fshr-sliderNavItem">';
    constructionHtml += $(slider.$slides[i]).data('title');
    constructionHtml += '</div>';
    return constructionHtml;
}



/* pozustatek z Objednavka.cshtml */

$(document).ready(function () {
    $("#souhlas").click(function () {
        $("#textpodminek").fadeIn();
        $("html, body").animate({ scrollTop: 600 }, 600);
    });
});


/* GREYJOY SUBMITER */

$(document).ready(function () {
    $(".js-greyjoySubmiter").click(function (e) {
        e.preventDefault();
        $(".js-GreyjoyOrder").submit();
    });
});


/* PRICELIST REVEALER */

$(document).ready(function (){
   $("body").on("click", ".js-pricelist-reveal", function (e) {
       var parent = $(this).closest(".fshr-priceListHolder");
       if($(this).hasClass("js-opened")){
           parent.find(".fshr-priceList--leftSide").slideUp();
           parent.find(".fshr-priceList--rightSide").slideUp();
           $(this).removeClass("js-opened");
           $(this).addClass("fshr-icon--arrowDown");
           $(this).removeClass("fshr-icon--arrowUp");
       }else{
           parent.find(".fshr-priceList--leftSide").slideDown();
           parent.find(".fshr-priceList--rightSide").slideDown();
           $(this).addClass("js-opened");
           $(this).removeClass("fshr-icon--arrowDown");
           $(this).addClass("fshr-icon--arrowUp");
       }
   });
});


/* SHOW HIDE MOBILE GREYJOY AT TERMS */

$(document).ready(function () {
    if($(window).outerWidth() < 800){

        var terminyaceny = $(".fshr-hotelDetailSection--termins");
        var greyjoyMobile = $(".fshr-hotelGreyjoyMobile");

        if(terminyaceny.length > 0 && terminyaceny.length > 0){
            $(".js-mobile-accordion").on("accordionactivate", function () {
                handleMobileGreyjoy(terminyaceny, greyjoyMobile);
            });

            $(document).scroll(function () {
                handleMobileGreyjoy(terminyaceny, greyjoyMobile);
            });
        }
    }

    function handleMobileGreyjoy(terms, greyjoy){
        if(isElementInViewport(terms)){
            greyjoy.hide();
        }else{
            greyjoy.show();
        }
    }
});
